export default "__VITE_ASSET__D4ez1OHS__"